/*
             _     _
 _____ ___ _| |_ _| |___ ___
|     | . | . | | | | -_|_ -|
|_|_|_|___|___|___|_|___|___|

"modules" is an addon for "mod" that helps you define behaviors for common
bits of HTML. A module could be a calendar widget, a search box, or an entire
page. The possibilities are literally almost certainly not endless.

# Dependencies
	- mod.js
	- mod.factory.js
	- mod.baseModule.js
	- jquery 1.7+

*/

!function($, mod) {

	// Get a new factory
	mod.modules = mod.factory.create(mod.baseModule);

	mod.modules.getKeyFromTypeSize = function(type, size) {
		var id = this.id_prefix + type;

		if (size) {
			id += this.id_delimiter + size;
		}

		return id;
	};

	mod.modules.id_prefix = "";
	mod.modules.id_delimiter = "";

}(jQuery, window.mod);